module.exports = __webpack_public_path__ + "img/tableseating.153a051b.jpg";